__turbopack_context__.v({
  "cover": "cover-mini-module__u8RmvW__cover",
  "coverOrnament": "cover-mini-module__u8RmvW__coverOrnament",
  "dogEarFlap": "cover-mini-module__u8RmvW__dogEarFlap",
  "dogEarWrap": "cover-mini-module__u8RmvW__dogEarWrap",
  "dogEared": "cover-mini-module__u8RmvW__dogEared",
});
